import { createAction, props } from '@ngrx/store';
import * as Play from './play.types';

export namespace PlayActions {
  export const cancelTimer = createAction('[Play] Cancel Timer');

  export const destroy = createAction('[Play] Destroy');

  export const exit = createAction('[Play] Exit');

  export const init = createAction('[Play] Init', props<Partial<Play.State>>());

  export const next = createAction('[Play] Next');

  export const previous = createAction('[Play] Previous');

  export const navigate = createAction(
    '[Play] Navigate',
    props<{
      clearReturnTo?: boolean;
      returnTo?: { sectionIndex: number; viewIndex: number };
      sectionIndex: number;
      viewIndex: number;
    }>()
  );

  export const setProgress = createAction(
    '[Play] Set Progress',
    props<{
      current?: number;
      percentage?: number;
      total?: number;
    }>()
  );

  export const startMeasuringTime = createAction(
    '[Play] Start Measuring Time',
    props<{
      time?: string;
    }>()
  );

  export const startTimer = createAction(
    '[Play] Start Timer',
    props<{ from: string; to: string }>()
  );

  export const frameLoading = createAction(
    '[Play] Is Frame Loading',
    props<{ isFrameLoading: boolean }>()
  );

  export const stopMeasuringTime = createAction(
    '[Play] Stop Measuring Time',
    props<{
      time?: string;
    }>()
  );
}
